import { FormControl, Grid, IconButton, Tooltip, InputLabel, Select, Table, TableBody
    , TableCell, TableRow, TextField, Typography, Stack, Box, InputAdornment } from '@mui/material'
import { AddCircle as IconAddCircle, Delete as IconDelete, Search as IconSearch, Edit as IconEdit } from "@mui/icons-material";
import api from "../../services/api";
import { styled } from '@mui/material/styles';
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addPersonaVinculaciones, removePersonaVinculaciones, setDatoPersonaVinculaciones
    , setPersonaVinculaciones, setTiposVinculaciones, initPersonBonding, defaultPersonaVinculaciones } from '../../redux/person/personBondingSlice'
import PersonSearch from './PersonSearch'
import PersonRegister from './PersonRegister';
import DialogYesNo from '../common/DialogYesNo';

import * as personaService from "../../services/personaService";
import * as catalogoService from "../../services/catalogoService";

const PersonBonding = (props) => {
    const dispatch = useDispatch();
    const sliceKey = props.sliceKey;
    const isReadOnly = props.isReadOnly;

    useEffect(() => {
        dispatch(initPersonBonding({ sliceKey }));
    }, [dispatch, sliceKey]);

    const personaVinculaciones = useSelector((state) => state.personBonding[sliceKey]?.personaVinculaciones)
    const tiposVinculaciones = useSelector((state) => state.personBonding[sliceKey]?.tiposVinculaciones)

    const [openSearchPersona, setOpenSearchPersona] = useState(false)
    const openCloseSearchPersona = () => { setOpenSearchPersona(!openSearchPersona); }
    const [openPersonRegister, setOpenPersonRegister] = useState(false)
    const openClosePersonRegister = () => { setOpenPersonRegister(!openPersonRegister); }
    const [openDialogDelete, setOpenDialogDelete] = useState(false)
    const openCloseDialogDelete = () => { setOpenDialogDelete(!openDialogDelete); }
    const [selectNumero, setSelectNumero] = useState(null);
    const [selectIdPersona, setSelectIdPersona] = useState(null);
    
    const fetchPersonaVinculaciones = useCallback(async () => {
        const response = await personaService.getsPersonaVinculacionView(props.id);

        if (response == null || response.length == 0)
            dispatch(setPersonaVinculaciones({sliceKey: sliceKey, data: defaultPersonaVinculaciones}));
        else
            dispatch(setPersonaVinculaciones({sliceKey: sliceKey, data: response}));
    }, [props.id, dispatch])
    const fetchTiposVinculaciones = useCallback(async () => {
        const response = await catalogoService.getCatalogosByPadre(42);
        dispatch(setTiposVinculaciones({sliceKey: sliceKey, data: response}));
    }, [])

    useEffect(() => {
        fetchPersonaVinculaciones();
    }, [props.id])

    useEffect(() => {
        fetchTiposVinculaciones();
    }, [])

    const setPersonSaved = (result) => {
        console.log(result)
        setItemValue(selectNumero, "idPersonaVinculo", result.id)
        setItemValue(selectNumero, "personaVinculo", result.nombres)
    }
    const setSelectSearchPersona = (select) => {
        setItemValue(selectNumero, "idPersonaVinculo", select.idPersona)
        setItemValue(selectNumero, "personaVinculo", select.nombres)
    }

    const deletePersonaVinculacion = async () => {
        await personaService.deletePersonaVinculacion(props.id, selectNumero);
        dispatch(removePersonaVinculaciones({sliceKey: sliceKey, numero: selectNumero}));
    }

    const setItemValue = (numero, name, value) => {
        dispatch(setDatoPersonaVinculaciones({sliceKey: sliceKey, numero: numero, name: name, value: value}))
    }

    return (
        <Grid container>
            <Grid item>
                <Box display="flex" alignItems="center">
                    <Typography variant="h7">
                        <Box sx={{ fontWeight: 'bold' }} padding={0}>
                            {"Vinculaciones (" + (personaVinculaciones?.length || 0) + ")"}
                        </Box>
                    </Typography>
                    <Tooltip title={"Agregar Vinculacion"} arrow>
                        <IconButton size="small" aria-label="Agregar Vinculacion" disabled={isReadOnly} onClick={() => {
                            dispatch(addPersonaVinculaciones(sliceKey))
                        }}>
                            <IconAddCircle />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Grid>
            <Grid container>
                <Table size="small">
                    <TableBody>
                        {personaVinculaciones?.map((row, index) => (
                            <TableRow key={row.numero} sx={(theme) => ({
                                backgroundColor: index % 2 === 1 ? theme.palette.action.selected : 'inherit',
                                "&:last-child td, &:last-child th": { borderRadius: "0.5em" },
                            })}>
                                <TableCell>
                                    <Grid container spacing={1} padding={0}>
                                        <Grid item xs={8} sm={4}>
                                            <FormControl required fullWidth>
                                                <InputLabel htmlFor="input-tipovinculo">Tipo</InputLabel>
                                                <Select
                                                    native
                                                    label="Tipo"
                                                    value={row.idTipoVinculo || 0}
                                                    fullWidth
                                                    onChange={(event, newValue) => {
                                                        setItemValue(row.numero, "idTipoVinculo", event.target.value)
                                                    }}
                                                    inputProps={{
                                                        name: 'idTipoVinculo',
                                                        id: 'input-tipovinculo',
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                >
                                                    <option key={0} value={0}>{"(Seleccione)"}</option>
                                                    {tiposVinculaciones?.map((row) => (
                                                        <option key={row.id} value={row.id}>{row.descripcion}</option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <Box display="flex" alignItems="center" gap={0}>
                                                <TextField
                                                    name="personaVinculo"
                                                    label="Persona"
                                                    value={row.personaVinculo || ""}
                                                    fullWidth
                                                    onChange={(event) => {
                                                        setItemValue(row.numero, "personaVinculo", event.target.value)
                                                    }}
                                                    size="small"
                                                    disabled={isReadOnly}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <Tooltip title={(row.idPersonaVinculo > 0 ? "Editar" : "Registrar") + " Persona"} arrow>
                                                                    <IconButton aria-label="registrar persona" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                                                        setSelectIdPersona(row.idPersonaVinculo)
                                                                        setSelectNumero(row.numero);
                                                                        openClosePersonRegister()
                                                                    }}>
                                                                        {row.idPersonaVinculo > 0 ? <IconEdit fontSize="small" /> : <IconAddCircle fontSize="small" />}
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <Tooltip title={"Buscar Persona"}>
                                                                    <IconButton aria-label="buscar persona" size="small" edge="end" disabled={isReadOnly} onClick={() => {
                                                                        setSelectNumero(row.numero);
                                                                        openCloseSearchPersona()
                                                                    }}>
                                                                        <IconSearch fontSize="small" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <Tooltip title={"Quitar Persona"} arrow>
                                                    <IconButton aria-label="delete" size='small' disabled={isReadOnly} onClick={() => {
                                                        if (row.idPersona > 0) {
                                                            setSelectNumero(row.numero);
                                                            setOpenDialogDelete(true);
                                                        }
                                                        else {
                                                            dispatch(removePersonaVinculaciones({sliceKey: sliceKey, numero: row.numero}));
                                                        }
                                                        }}>
                                                        <IconDelete />
                                                    </IconButton>
                                                </Tooltip>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
            <PersonSearch empresa="N" open={openSearchPersona} openClose={openCloseSearchPersona} setSelection={setSelectSearchPersona}/>
            <PersonRegister id={selectIdPersona} sliceKey="personRegister" open={openPersonRegister} openClose={openClosePersonRegister} setNewPersonSaved={setPersonSaved}/>
            <DialogYesNo open={openDialogDelete} openClose={openCloseDialogDelete} setYes={deletePersonaVinculacion} setNo={() => { return }}
                titulo={"Borrar Vinculacion"}
                texto={"Esta seguro de borrar la vinculacion?"} ></DialogYesNo>
        </Grid>
    )
}

export default PersonBonding;
